export const ownerscabinImageOptions = {
  angle: 'ownerscabin',
  staticOptions: {
    Floorboard: 1,
    Handrail: 1,
    Worktop: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    FabricOwnersCabin: 1,
    FabricAftCabin: 1,
    AftCabinLayout: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: null
    },
    {
      option: 'FabricOwnersCabin',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/ownerscabin.js